export class RequestPool {
	constructor(concurrency = 10) {
		this.concurrency = concurrency;
		this.activeRequests = [];
		this.requestQueue = [];
	}

	append(requestCallback) {
		let resolver;
		const promise = new Promise(resolve => (resolver = resolve));
		this.requestQueue.push({ requestCallback, resolver });
		this.startIfPossible();
		return promise;
	}

	abort() {
		this.activeRequests.forEach(request => request.cancel());
		this.activeRequests = [];
		this.requestQueue = [];
	}

	startIfPossible() {
		while (
			this.activeRequests.length < this.concurrency &&
			this.requestQueue.length
		) {
			const { requestCallback, resolver } = this.requestQueue.shift();
			const request = requestCallback();
			request.then(() => this.onRequestFulfilled(request, resolver));
			this.activeRequests.push(request);
		}
	}

	onRequestFulfilled(request, resolver) {
		const requestIndex = this.activeRequests.indexOf(request);
		this.activeRequests.splice(requestIndex, 1);
		resolver(request);
		this.startIfPossible();
	}

	isEmpty() {
		return this.activeRequests.length === 0 && this.requestQueue.length === 0;
	}
}
